var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"overlay-color":"white","width":"800px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"list-tooltip",staticStyle:{"vertical-align":"text-bottom","display":"inline"}},'div',attrs,false),on),[_vm._t("modal-trigger")],2)]}}],null,true)},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',[_vm._t("modal-content")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }